import ActionCable from 'actioncable';
import { useEffect } from 'react';
import { useOptionalSession } from 'src/contexts/SessionContext';

/**
 * Hook that subscribes to the ReloadChannel and automatically reloads the page
 * when a reload command is received from the server
 */
export const useReloadChannel = () => {
  const { user } = useOptionalSession();

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    const cable = ActionCable.createConsumer('/cable/');
    const subscription = cable.subscriptions.create(
      {
        channel: 'ReloadChannel',
      },
      {
        connected: (data) => {
          // eslint-disable-next-line no-console
          console.log('ReloadChannel#connected', data);
        },
        disconnected: (data) => {
          // eslint-disable-next-line no-console
          console.log('ReloadChannel#disconnected', data);
        },
        received: (data) => {
          // eslint-disable-next-line no-console
          console.log('ReloadChannel#received', data);
          if (data.action === 'reload') {
            // eslint-disable-next-line no-console
            console.log('Reload command received, reloading page...');
            window.location.reload();
          }
        },
      }
    );

    return () => {
      cable.subscriptions.remove(subscription);
    };
  }, [user?.id]);
};
